import BaseAPI from "../api";

const path: string = "dashboards";


export class DashboardsApi extends BaseAPI {
    static complaintStatus(): Promise<any> {
        return this.api.get(`${path}/complaints_status`)
    }
    static complaintType():Promise<any>{
        return this.api.get(`${path}/complaints_type`)
    }
}